module.exports = __webpack_public_path__ + "static/img/team-pic1.82f60355.png";